import React from "react";
import {useUserQueryQuery} from "../../generated/graphql";
import {GraphQlSelect} from "./GraphQlSelect";
import { GraphQlSelectId } from "./GraphQlSelectId";

export const UserSelect = (props) => {
    const query = useUserQueryQuery();
    return props.valueIsId?<GraphQlSelectId queryResult={query} {...props}  labelField="name" />:<GraphQlSelect queryResult={query} {...props}  labelField="name" />;
}

